import { render, staticRenderFns } from "./AllCounsel.vue?vue&type=template&id=b464dae8&scoped=true&"
import script from "./AllCounsel.vue?vue&type=script&lang=js&"
export * from "./AllCounsel.vue?vue&type=script&lang=js&"
import style0 from "./AllCounsel.vue?vue&type=style&index=0&id=b464dae8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b464dae8",
  null
  
)

export default component.exports